import { render, staticRenderFns } from "./WorkflowList.vue?vue&type=template&id=f4c560de&scoped=true"
import script from "./WorkflowList.vue?vue&type=script&lang=js"
export * from "./WorkflowList.vue?vue&type=script&lang=js"
import style0 from "./WorkflowList.vue?vue&type=style&index=0&id=f4c560de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c560de",
  null
  
)

export default component.exports